import './utils/lite-youtube-embed'

import './style/styles-algolia-list.scss'

import { createComponent } from '@bigyouth/base'
import * as features from './features/exports/algolia-list'

Object.values(features).forEach(createComponent)
